import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { ProductClientLinks } from '../types/product';

export function useProductClientLinks(id: string | null, enabled: boolean) {
  return useQuery({
    queryKey: ['product-client-links', id],
    queryFn: () => api<ProductClientLinks>(`/products/${id}/client-links`),
    enabled: !!id && enabled,
  });
}
